import { render, staticRenderFns } from "./django-support.page.vue?vue&type=template&id=ff347030&scoped=true&"
import script from "./django-support.page.vue?vue&type=script&lang=js&"
export * from "./django-support.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff347030",
  null
  
)

export default component.exports